import { JSX, useEffect } from "react";
import { MotiveScoreValueEnum } from "@app/projects/servicing-provider/"
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface MotiveAppropriatenessFilterProps {
  mappedValues: DropdownItem<MotiveScoreValueEnum>[];
  selectedValues: DropdownItem<MotiveScoreValueEnum>[];
  setSelectedValues: (selectedValues: DropdownItem<MotiveScoreValueEnum>[]) => void;
  testId: string;
}

const MotiveAppropriatenessFilter = (props: MotiveAppropriatenessFilterProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedValues(props.mappedValues);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === props.mappedValues.length ? "All" : null}
      items={props.mappedValues}
      onSelectionChanged={(selectedValues: DropdownItem<MotiveScoreValueEnum>[]) => { props.setSelectedValues(selectedValues) }}
      label="Motive Appropriateness"
      selectedItems={props.selectedValues}
      testId={props.testId}
    />
  )
}

export default MotiveAppropriatenessFilter;
